import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AppConfig } from '@config/app.config';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import { Menu } from '@shared/interfaces/menu';
import { BcAdalAngularService } from 'bc-adal-angular';
import { Observable } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html'
})
export class MenuComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public isLoggedIn$: Observable<boolean>;
  public menu: Array<Menu> = [];
  public activeRoute: string;
  public userName: string;
  public name: string;

  constructor(
    public appConfig: AppConfig,
    public authenticationService: AuthenticationService,
    private adalService: BcAdalAngularService,
    public generalsService: GeneralsService,
    private router: Router
  ) {
    this.navigateStart();
  }

  ngOnInit() {
    this.generalsService.itemMenu$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(result => {
        if (result.status === undefined) {
          this.menu = result;
        }
      });

    this.generalsService.getMenu();
    this.isLoggedIn$ = this.authenticationService.isLoggedIn;

    const userInfor = this.adalService.userInfo;
    this.userName = userInfor.userName;
    this.name =
      userInfor.profile.given_name + ' ' + userInfor.profile.family_name;
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  logout() {
    this.authenticationService.logout();
  }

  isParentActive(children: any) {
    return (
      children.filter((item: any) => {
        return this.activeRoute && this.activeRoute.indexOf(item.link) !== -1;
      }).length > 0
    );
  }

  navigateStart() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationStart),
        takeUntil(this.constants.destroy$)
      )
      .subscribe((result: NavigationStart) => (this.activeRoute = result.url));
  }
}
